<template>
  <b-form-group class="teamReportCheckboxFormGroup" v-if="isSelectable">
    <input type="checkbox" class="teamReportCheckbox" :checked="checkboxValue" @click="onRowSelected" />
  </b-form-group>
</template>

<script>

export default {
  props: {
    item: Object,
    selectedRows: Array,
    onSelectedRowsChange: Function
  },
  computed: {
    isSelectable() {
      if (!this.item.completedDate) return false
      const rows = [...this.selectedRows]
      if (!rows || (rows && rows.length === 0)) return true
      if (rows && rows.length > 0 && rows[0] && rows[0].testMethodName === this.item.testMethodName) return true
      return false
    },
    checkboxValue() {
      return !!(this.selectedRows.findIndex(y => y.id === this.item.id) > -1)
    }
  },
  methods: {
    onRowSelected: function() {
      const rows = [...this.selectedRows]
      if (!this.isSelectable) return

      const itemIndex = rows.findIndex(y => y.id === this.item.id)
      if (itemIndex === -1) {
        rows.push(this.item)
      } else if (itemIndex >= 0) {
        rows.splice(itemIndex, 1)
      }
      this.onSelectedRowsChange(rows)
    }
  }
}
</script>

<style scoped>
.teamReportCheckboxFormGroup {
  margin-bottom: 0;
}
.teamReportCheckbox {
  display: block;
  margin: 0 auto;
}
</style>
